import React, { useState } from "react";
import icon from '../assets/images/icona.png';
import {Col,Row,Container, Label} from "reactstrap";
import Form from "../components/Form";
import ServicesCardMain from "../components/ServicesCardMain";
import Section from "./Section";
import Preloader from "../components/Preloader";
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';

const Vendita = () =>{
    const formLayout = {
        name:'vendita',title:"Compila il form e ti risponderemo via mail",layout:[
            {fieldName:'nome',fieldDimensions:12,fieldLabel:'Nome e Cognome',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'email',fieldDimensions:6,fieldLabel:'Indirizzo email',fieldValidation:{required:true},fieldType:'email'},
            {fieldName:'telefono',fieldDimensions:6,fieldLabel:'Numero di telefono',fieldValidation:{required:true},fieldType:'number'},
            {fieldName:'messaggio',fieldDimensions:12,fieldLabel:'Messaggio',fieldValidation:{},fieldType:'textarea'},
        ]
    }    
    return ( 
          <React.Fragment>
            <Preloader />
            <Navbar />
            <Section leftSide="Vendita"></Section>
            <ServicesCardMain imgsrc={icon} title="Vendita" caption="Tenergia s.r.l. offre ai suoi clienti una vastissima gamma di Gruppi elettrogeni, Torri faro e UPS Gruppi di continuità nuovi in pronta consegna o su ordinazione, scelti tra le migliori marche presenti sul mercato mondiale come Pramac, Mahindra e Mosa. Tenergia s.r.l. inoltre dispone, per chi vuole risparmiare in assoluta sicurezza, di un parco Usato revisionato in sede e garantito 12 mesi." />
          <Form name={formLayout.name} title={formLayout.title} layout={formLayout.layout}></Form>
          <Footer />
          <FooterAlt />
          </React.Fragment>)
}

export default Vendita;